import { api } from 'app/app.api';

import {
  DeleteAnnouncementApiArg,
  DeleteAnnouncementApiResponse,
  ReadAnnouncementApiArg,
  ReadAnnouncementApiResponse,
  ReadAnnouncementsApiResponse,
  UpdateAnnouncementApiArg,
  UpdateAnnouncementApiResponse,
  UploadAnnouncementApiArg,
  UploadAnnouncementApiResponse,
} from './types/announcementsApi.types';

export const announcementsApi = api
  .enhanceEndpoints({
    addTagTypes: ['Announcement'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readAnnouncements: builder.query<ReadAnnouncementsApiResponse, void>({
        query: () => ({
          version: 1,
          path: 'announcements',
        }),
        providesTags: [{ type: 'Announcement', id: 'LIST' }],
      }),
      readAnnouncement: builder.query<
        ReadAnnouncementApiResponse,
        ReadAnnouncementApiArg
      >({
        query: ({ id }) => ({
          version: 1,
          path: `announcements/${id}`,
        }),
        providesTags: (_, __, { id }) => [{ type: 'Announcement', id }],
      }),
      updateAnnouncement: builder.mutation<
        UpdateAnnouncementApiResponse,
        UpdateAnnouncementApiArg
      >({
        query: ({ id, name }) => ({
          version: 1,
          path: `announcements/${id}`,
          method: 'PATCH',
          body: { name },
        }),
        invalidatesTags: (_, error, { id }) =>
          error
            ? []
            : [
                { type: 'Announcement', id: 'LIST' },
                { type: 'Announcement', id },
              ],
      }),
      uploadAnnouncement: builder.mutation<
        UploadAnnouncementApiResponse,
        UploadAnnouncementApiArg
      >({
        query: ({ file, name }) => ({
          version: 1,
          path: 'announcements',
          method: 'POST',
          params: { pretty_name: name },
          headers: { 'Content-Type': file.type },
          body: file,
        }),
        invalidatesTags: (_, error) =>
          error ? [] : [{ type: 'Announcement', id: 'LIST' }],
      }),
      deleteAnnouncement: builder.mutation<
        DeleteAnnouncementApiResponse,
        DeleteAnnouncementApiArg
      >({
        query: ({ id }) => ({
          version: 1,
          path: `announcements/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (_, error) =>
          error ? [] : [{ type: 'Announcement', id: 'LIST' }],
      }),
    }),
  });
